module.exports = __webpack_public_path__ + "img/camera.d6bb20c3.png";